import React, { useState, useEffect, useRef } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { Card, Form, Button, Row, Col, Modal } from "react-bootstrap";
import Select from "react-select";
import axios from "axios";
import { API_URL_LOCAL } from "..";
import { Icon } from "@iconify/react/dist/iconify.js";
import swal from "sweetalert";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables.js";
import "datatables.net-responsive-dt/js/responsive.dataTables.js";
import "datatables.net-responsive-dt/css/responsive.dataTables.css";

const TimeOffPage = () => {
  const [timeOffs, setTimeOffs] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [policies, setPolicies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({
    id: null,
    employee_id: null,
    policy_id: null,
    start_date: "",
    end_date: "",
    description: "",
  });
  const [isEdit, setIsEdit] = useState(false);
  const tableRef = useRef(null);

  // Fetch data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        if (!user || !user.id) throw new Error("User not found in localStorage");

        // Fetch time-off requests
        const timeOffResponse = await axios.get(`${API_URL_LOCAL}/api/time-off/all?org_id=${user.id}`);
        setTimeOffs(timeOffResponse.data.leaves || []);

        // Fetch employees
        
        const empResponse = await axios.get(`${API_URL_LOCAL}/api/employee/fetch/${user.id}`);
        const empData = empResponse.data.employees.map((emp) => ({
          value: emp.id,
          label: `${emp.first_name} ${emp.last_name}`,
        }));
        setEmployees(empData);

        // Fetch policies
        const leaveTypeOptions = [
            { value: "Annual", label: "Annual Leave" },
            { value: "Sick", label: "Sick Leave" },
            { value: "Maternity", label: "Maternity Leave" },
            { value: "Paternity", label: "Paternity Leave" },
            { value: "Casual", label: "Casual Leave" },
            { value: "Unpaid", label: "Unpaid Leave" },
          ];
        setPolicies(leaveTypeOptions);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Initialize DataTable
  useEffect(() => {
    if (!loading && tableRef.current && timeOffs.length >= 0) {
      const table = $(tableRef.current).DataTable({
        data: timeOffs,
        columns: [
          { data: "employee.first_name", title: "Employee" },
          {
            data: "createdAt",
            title: "Apply Date",
            render: (data) => new Date(data).toLocaleDateString(),
          },
          {
            data: null,
            title: "Duration",
            render: (data) => {
              const start = new Date(data.from_date);
              const end = new Date(data.to_date);
              const days = Math.ceil((end - start) / (1000 * 60 * 60 * 24)) + 1;
              return `${days} day${days !== 1 ? "s" : ""}`;
            },
          },
          { data: "leave_type", title: "Time Off Policy" },
          {
            data: "status",
            title: "Status",
            render: (data) => {
              const className =
                data === "Approved"
                  ? "bg-success-50 text-success-600 border-success-50"
                  : data === "Declined"
                  ? "bg-danger-50 text-danger-600 border-danger-50"
                  : "bg-warning-50 text-warning-600 border-warning-50";
              return `<span class="badge ${className}">${data}</span>`;
            },
          },
          {
            data: null,
            title: "Action",
            orderable: false,
            render: (data, type, row) => {
              let buttons = `
                <div class="d-flex gap-2">
                  <button class="btn btn-outline-primary px-8 py-4 radius-8 edit-btn" data-id="${row.id}">
                    <i class="ph ph-pencil" style="font-size: 18px;"></i>
                  </button>
                  <button class="btn btn-outline-danger px-8 py-4 radius-8 delete-btn" data-id="${row.id}">
                    <i class="ph ph-trash" style="font-size: 18px;"></i>
                  </button>
              `;
              if (row.status === "Pending" || row.status === "pending" ) {
                buttons += `
                  <button class="btn btn-outline-success px-8 py-4 radius-8 approve-btn" data-id="${row.id}">
                    <i class="ph ph-check" style="font-size: 18px;"></i>
                  </button>
                  <button class="btn btn-outline-danger px-8 py-4 radius-8 decline-btn" data-id="${row.id}">
                    <i class="ph ph-x" style="font-size: 18px;"></i>
                  </button>
                `;
              }
              buttons += `</div>`;
              return buttons;
            },
          },
        ],
        responsive: true,
        pageLength: 10,
        lengthMenu: [10, 20, 50],
        order: [[1, "desc"]], // Sort by Apply Date descending
        language: {
          emptyTable: "No time-off requests found",
        },
        destroy: true, // Reinitialize on state change
      });

      // Handle button clicks
      $(tableRef.current).on("click", ".edit-btn", function () {
        const id = $(this).data("id");
        
        const timeOff = timeOffs.find((t) => t.id === id);
        openModal(timeOff);
      });

      $(tableRef.current).on("click", ".delete-btn", function () {
        const id = $(this).data("id");
        handleDeleteTimeOff(id);
      });

      $(tableRef.current).on("click", ".approve-btn", function () {
        const id = $(this).data("id");
        handleStatusChange(id, "Approved");
      });

      $(tableRef.current).on("click", ".decline-btn", function () {
        const id = $(this).data("id");
        handleStatusChange(id, "Declined");
      });

      // Cleanup
      return () => {
        table.destroy();
        $(tableRef.current).off("click");
      };
    }
  }, [timeOffs, loading]);

  // Handle modal input changes
  const handleModalChange = (field, value) => {
    setModalData({ ...modalData, [field]: value });
  };

  // Open modal for add/edit
  const openModal = (timeOff = null) => {
    if (timeOff) {
      setModalData({
        id: timeOff.id,
        employee_id: employees.find((e) => e.value === timeOff.emp_id) || null,
        policy_id: policies.find((p) => p.value === timeOff.leave_type) || null,
        start_date: timeOff.from_date,
        end_date: timeOff.to_date,
        description: timeOff.comments || "",
      });
      setIsEdit(true);
    } else {
      setModalData({
        id: null,
        employee_id: null,
        policy_id: null,
        start_date: "",
        end_date: "",
        description: "",
      });
      setIsEdit(false);
    }
    setShowModal(true);
  };

  // Save time-off request
  const handleSaveTimeOff = async () => {
    const user = JSON.parse(localStorage.getItem('user'));
    try {
      if (
        !modalData.employee_id ||
        !modalData.policy_id ||
        !modalData.start_date ||
        !modalData.end_date
      ) {
        swal("Validation Error","Employee, Policy, Start Date, and End Date are required","error");
        return;
      }
      if (new Date(modalData.end_date) < new Date(modalData.start_date)) {
        swal("Validation","End Date must be on or after Start Date","error");
        return;
      }
      
      const payload = {
        emp_id: modalData.employee_id.value,
        leave_type: modalData.policy_id.value,
        from_date: modalData.start_date,
        to_date: modalData.end_date,
        comments: modalData.description,
        org_id :  user.id
      };

      let response;
      if (isEdit) {
        response = await axios.put(
          `${API_URL_LOCAL}/api/time-off/${modalData.id}`,
          payload
        );
      } else {
        response = await axios.post(`${API_URL_LOCAL}/api/time-off/create`, payload);
      }

      if (response.status === 200 || response.status === 201) {
        const updatedTimeOff = {
          ...payload,
          id: isEdit ? modalData.id : response.data.leave.id,
          employee: {first_name: modalData.employee_id.label},
          leave_type: modalData.policy_id.label,
          createdAt:  response.data.leave.createdAt,
          status: isEdit ? timeOffs.find((t) => t.id === modalData.id).status : "pending",
        };
      
        setTimeOffs(
          isEdit
            ? timeOffs.map((t) => (t.id === modalData.id ? updatedTimeOff : t))
            : [...timeOffs, updatedTimeOff]
        );
        setShowModal(false);
        setFormData(null);
        setLeaveQuotas([])
        swal("Time-off",`Time-off ${isEdit ? "updated" : "created"} successfully!` , "success");
      }
    } catch (err) {
        swal("Server Error",`Failed to ${isEdit ? "update" : "create"} time-off: ${err.message}` , "error");
    }
  };

  // Delete time-off request
  const handleDeleteTimeOff = (id) => {
    swal({
      title: "Are you sure?",
      text: "You want to delete this time-off request?",
      icon: "warning",
      buttons: ["No", "Yes"],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const response = await axios.delete(`${API_URL_LOCAL}/api/time-off/${id}`);
          if (response.status === 200) {
            setTimeOffs(timeOffs.filter((t) => t.id !== id));
            swal("Success", "Time-off request deleted successfully!", "success");
          } else {
            throw new Error("Failed to delete time-off request");
          }
        } catch (err) {
          swal("Error", `Failed to delete time-off request: ${err.message}`, "error");
        }
      }
    });
  };

  // Approve/Decline time-off request
  const handleStatusChange = async (id, status) => {
    try {
      const response = await axios.put(`${API_URL_LOCAL}/api/time-off/status/${id}`, {
        status,
      });
      if (response.status === 200) {
        setTimeOffs(
          timeOffs.map((t) => (t.id === id ? { ...t, status } : t))
        );
        swal("Information Updated",`Time-off request ${status.toLowerCase()} successfully!` , "success");
        
        setFormData(null);
        setLeaveQuotas([])
      } else {
        throw new Error(`Failed to ${status.toLowerCase()} time-off request`);
      }
    } catch (err) {
      swal("Error",`Failed to ${status.toLowerCase()} time-off request: ${err.message}`, "error");
    }
  };
  const [formData,setFormData] = useState(null)
  const [leaveQuotas, setLeaveQuotas] = useState([{ leave_type: null, days: "" }]);

  const leaveTypeOptions = [
    { value: "Annual", label: "Annual Leave" },
    { value: "Sick", label: "Sick Leave" },
    { value: "Maternity", label: "Maternity Leave" },
    { value: "Paternity", label: "Paternity Leave" },
    { value: "Casual", label: "Casual Leave" },
    { value: "Unpaid", label: "Unpaid Leave" },
  ];
  const fetchData = async (id = null) => {
   if(id){
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user || !user.id) throw new Error("User not found in localStorage");
      const empResponse = await axios.get(`${API_URL_LOCAL}/api/employee/fetch-single/${id}`);
      const empData = empResponse.data.employee;
      setFormData({
        personal: {
          first_name: empData.first_name || "",
          last_name: empData.last_name || "",
          email_address: empData.email_address || "",
          phone_number: empData.phone_number || "",
          username: empData.username || "",
          profile_image: empData.profile_image,
        },
       
      
       
      });
    //   console.log(empData)
    let initialLeaveQuotas = [{ leave_type: null, days: "" }];
    if (
      empData.job?.annual_leaves &&
      empData.job?.annual_leaves_type
    ) {
      const leaveCounter = empData.job.annual_leaves.split(",");
      const leaveType = empData.job.annual_leaves_type.split(",");
      if (leaveCounter.length === leaveType.length) {
        initialLeaveQuotas = leaveCounter.map((days, index) => {
          const type = leaveType[index];
          const option = leaveTypeOptions.find((opt) => opt.value === type);
          return {
            leave_type: option || { value: type, label: type }, // Fallback if type not in options
            days: days.trim(),
          };
        });
      }
    }
    console.log(initialLeaveQuotas)
    setLeaveQuotas(initialLeaveQuotas);
    } catch (err) {
      setError(err.message);
    }
    }
  };
  useEffect(()=>{
    fetchData(modalData.employee_id?.value)
  },[modalData])

  if (loading) return <div className="text-center">Loading...</div>;
  if (error)
    return (
      <div className="alert alert-danger bg-danger-50 text-danger-600 border-danger-50 px-24 py-11 mb-20 fw-semibold text-lg radius-8">
        {error}
      </div>
    );

  return (
    <MasterLayout>
      <Breadcrumb title="Time Off" />
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <div className="d-flex justify-content-between mb-20">
            <h4 className="fw-semibold text-primary-dark">Time Off Requests</h4>
            <Button
              variant="primary"
              className="text-md px-24 py-8 radius-8"
              onClick={() => openModal()}
            >
              <Icon fontSize={22} icon="mdi:plus" className="me-2" />
              Add Time Off
            </Button>
          </div>
          <div className="table-responsive">
            <table
              id="timeoff-table"
              ref={tableRef}
              className="table table-striped table-bordered"
              style={{ width: "100%" }}
            >
              <thead>
                <tr>
                  <th>Employee</th>
                  <th>Apply Date</th>
                  <th>Duration</th>
                  <th>Time Off Policy</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody></tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Time Off Modal */}
      <Modal style={{ zIndex: 9999 }} backdrop='static' show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            <h6>
              <Icon fontSize={22} icon="mdi:calendar-remove" className="me-2" />
              {isEdit ? "Edit Time Off Request" : "Add Time Off Request"}
            </h6>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-20">
               {
                formData && (
                  <Row style={{columnGap: 0}}>
                <Col md="3">
                    <img style={{width: 80, height: 80,borderRadius: 100}} src={formData?.personal?.profile_image}  alt="Image here"/>
                </Col>
                <Col md="4" className="text-start" style={{justifyContent:'center'}}>
                    <p>{formData?.personal?.first_name + formData?.personal?.last_name}</p>
                    <p>{formData?.personal?.username || 'N/a'}</p>
                </Col>
              </Row>
                )
               }
               {
                leaveQuotas.length === 0 ? <p>No Quota Assigned to this employee</p> :  (
                  <Row style={{paddingTop: 10}}>
                  {
                    leaveQuotas.map((e)=>{
                      if(e.leave_type === null){
                        return (
                          <Row>
                            <Col>
                            <p>No Quota Assigned to this employee</p>
                            </Col>
                            </Row>
                        );
                      }else{
                       return(
                        <Col md="4">
                        <label style={{fontWeight:'bold'}}>{e.leave_type?.label}</label>
                        <p>{e.days}</p>
                       </Col>
                       );
                      }
                      
                    })
                  }
                
              </Row>
                )
               }
              <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                <Icon fontSize={22} icon="mdi:account" className="me-2" />
                  Employee
              </Form.Label>
              <Select
                options={employees}
                value={modalData.employee_id}
                onChange={(selected) => handleModalChange("employee_id", selected)}
                placeholder="Select Employee"
                isDisabled={isEdit}
              />
            </Form.Group>
            <Form.Group className="mb-20">
              <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                <Icon fontSize={22} icon="mdi:calendar-blank" className="me-2" />
                Time Off Policy
              </Form.Label>
              <Select
                options={policies}
                value={modalData.policy_id}
                onChange={(selected) => handleModalChange("policy_id", selected)}
                placeholder="Select Policy"
              />
            </Form.Group>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-20">
                  <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                    <Icon fontSize={22} icon="mdi:calendar-start" className="me-2" />
                    Start Date
                  </Form.Label>
                  <Form.Control
                    type="date"
                    value={modalData.start_date}
                    onChange={(e) => handleModalChange("start_date", e.target.value)}
                    className="radius-8"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-20">
                  <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                    <Icon fontSize={22} icon="mdi:calendar-end" className="me-2" />
                    End Date
                  </Form.Label>
                  <Form.Control
                    type="date"
                    value={modalData.end_date}
                    onChange={(e) => handleModalChange("end_date", e.target.value)}
                    className="radius-8"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="mb-20">
              <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                <Icon fontSize={22} icon="mdi:comment" className="me-2" />
                Description
              </Form.Label>
              <Form.Control
                as="textarea"
                value={modalData.description}
                onChange={(e) => handleModalChange("description", e.target.value)}
                className="radius-8"
                rows={4}
                placeholder="Enter reason for time off"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            className="text-md px-24 py-8 radius-8"
            onClick={() => setShowModal(false)}
          >
            <Icon fontSize={22} icon="mdi:close" className="me-2" />
            Cancel
          </Button>
          <Button
            variant="primary"
            className="text-md px-24 py-8 radius-8"
            onClick={handleSaveTimeOff}
          >
            <Icon fontSize={22} icon="mdi:content-save" className="me-2" />
            {isEdit ? "Update" : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>
    </MasterLayout>
  );
};

export default TimeOffPage;